import { SocialSignUpButton } from "../SocialSignUpButton";
import styles from "./SocialSignUpGroup.module.css";
import { LandingPageTemplateResponse, SignInProvider } from "@/types/landing";
import { Site } from "@/types/sites";
import { useState } from "react";
import useResizeListener from "../../../hooks/useResizeListener";

type SocialSignUpGroupProps = ({
    signUpProviderGroup,
    fromPopup,
    site,
    landingPage,
    onOfferPage,
}: {
    signUpProviderGroup: SignInProvider[];
    fromPopup?: boolean;
    site: Site | null;
    landingPage: LandingPageTemplateResponse | null;
    onOfferPage?: boolean;
}) => React.ReactElement;

export const SocialSignUpGroup: SocialSignUpGroupProps = ({
    signUpProviderGroup,
    fromPopup,
    site,
    landingPage,
    onOfferPage,
}) => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useResizeListener(() => {
        setIsMobile(window.innerWidth < 768);
    });

    const getStyles = (styleName: string) => {
        const styleArray = [styles[styleName]];

        if (fromPopup) {
            styleArray.push(styles[`${styleName}_popup`]);
        }

        return styleArray.join(" ");
    };

    const aProviderHasCustomMobileText = signUpProviderGroup.some(
        (provider) => provider.buttonTextMobile
    );

    const isMobileWithNoText = isMobile && !aProviderHasCustomMobileText;

    return (
        <>
            <span
                className={
                    isMobileWithNoText
                        ? styles.sideBySideContainer
                        : styles.verticalStackContainer
                }
            >
                {signUpProviderGroup.map((provider, index) => (
                    <SocialSignUpButton
                        key={index}
                        provider={provider}
                        site={site}
                        landingPage={landingPage}
                        onOfferPage={onOfferPage}
                        isMobile={isMobile}
                    />
                ))}
            </span>
            {signUpProviderGroup.length > 0 && (
                <span className={styles.container}>
                    <span className={styles.leftSide}>
                        <span className={getStyles("leftLine")}></span>
                    </span>
                    <span className={styles.textContainer}>
                        <span className={styles.text}>or</span>
                    </span>
                    <span className={styles.rightSide}>
                        <span className={getStyles("rightLine")}></span>
                    </span>
                </span>
            )}
        </>
    );
};
